import React, { useContext } from "react";
import { DesignAssetContext } from "../../pages/CustomHooks/ContextApi";
import embLabels from "../../config/emb-labels-en.json";

const Busbar = (secondBusbar) => {
  const {
    coordinates: {
      busbar: { x2 },
      busbarCordinates,
    },
    switchboardType,
    loadSide,
  } = useContext(DesignAssetContext);
  return (
    <>
      {switchboardType === embLabels.EXISTING_SWITCHBOARD ? (
        <svg>
          <g id="busbar">
            <line
              x1={busbarCordinates.x11}
              y1={busbarCordinates.y11}
              x2={busbarCordinates.x21}
              y2={busbarCordinates.y21}
              stroke="var(--se-sld-circline)"
              strokeWidth="3"
            />
            {secondBusbar && (
              <line
                x1={busbarCordinates.x12}
                y1={loadSide === "LOAD_SIDE" ? "470" : busbarCordinates.y12}
                x2={busbarCordinates.x22}
                y2={loadSide === "LOAD_SIDE" ? "470" : busbarCordinates.y22}
                stroke="var(--se-sld-circline)"
                strokeWidth="3"
              />
            )}
          </g>
        </svg>
      ) : (
        <svg>
          <g id="busbar" >
            <line
              x1={busbarCordinates.x11}
              y1={busbarCordinates.y11}
              x2={busbarCordinates.x21}
              y2={busbarCordinates.y21}
              stroke="var(--se-sld-circline)"
              strokeWidth="3"
            />
          </g>
        </svg>
      )}
    </>
  );
};

export default Busbar;
